/** Campaigns module URL prefix */
export const CAMPAIGNS_BASE = '/campaigns';

export const campaignPaths = {
  // Campaigns
  list: `${CAMPAIGNS_BASE}/list`,
  create: `${CAMPAIGNS_BASE}/create`,
  edit: (id: string) => `${CAMPAIGNS_BASE}/${id}/edit`,
  report: (id: string) => `${CAMPAIGNS_BASE}/${id}/report`,
  // Automations
  automations: `${CAMPAIGNS_BASE}/automations`,
  automationEdit: (id: string) => `${CAMPAIGNS_BASE}/automations/${id}/edit`,
  // Tracking sources
  sources: `${CAMPAIGNS_BASE}/sources`,
  sourcesCreate: `${CAMPAIGNS_BASE}/sources/create`,
  sourceEdit: (id: string) => `${CAMPAIGNS_BASE}/sources/${id}/edit`,
  // Opt-out review queue
  optOuts: `${CAMPAIGNS_BASE}/opt-outs`,
  // Settings
  settings: `${CAMPAIGNS_BASE}/settings`,
  // Performance report, shown in the Reports section
  performanceReport: '/reports/campaigns',
} as const;

/** Routes owned by other modules that Campaigns links out to. */
export const externalPaths = {
  offerCreate: '/offers/new',
  loyaltyNotifications: '/loyalty/notifications',
  // Customers and segments are kept in the Customers module.
  customerDirectory: '/customers/directory',
  customerProfile: (id: string) => `/customers/directory/${id}`,
  customerSegments: '/customers/segments',
  customerSegmentCreate: '/customers/segments/create',
} as const;
